export const locale = {
  'ROWOPERATION' : {
    'ADD' : 'Add',
    'EDIT' : 'Edit',
    'REMOVE' : 'Remove',
    'COPY' : 'Copy',
  }
};
